import dayjs from 'dayjs';

import { LEGAL_AGE } from '@/lib/consts';

import { isDateTimeISO, isFormattedDate } from '../components/Forms/Validation';

function padTo2Digits(num: number): string {
  return num.toString().padStart(2, '0');
}

export const getDateWithoutTime = (date: Date | string): Date => {
  const newDate = typeof date === 'string' ? new Date(date) : date;
  newDate.setHours(0, 0, 0, 0);

  return newDate;
};

export const formatCacheDate = (date: Date): Nullable<string> => formatDate(date, '-', true);

export const getTimeFromISOString = (isoString: string): string => {
  const date = new Date(isoString);

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
};

type PossibleDateSeparators = '.' | '/' | '-';

export const formatDate = (
  date: Nullable<Date | dayjs.Dayjs | string>,
  separator: PossibleDateSeparators = '.',
  format = false,
  withTime = false,
): Nullable<string> => {
  if (!date) return null;

  const originalValue = date;

  if (!(date instanceof Date)) {
    if (dayjs.isDayjs(date)) {
      date = date.toDate();
    } else if (isDateTimeISO(date) || isFormattedDate(date)) {
      date = new Date(date || 0);
    } else {
      return originalValue !== null ? String(originalValue) : null;
    }
  }

  let year;
  let month;
  let day;
  let hours;
  let minutes;

  if (withTime) {
    year = date.getFullYear();
    month = date.getMonth() + 1;
    day = date.getDate();
    hours = date.getHours();
    minutes = date.getMinutes();
  } else {
    year = date.getUTCFullYear();
    month = date.getUTCMonth() + 1;
    day = date.getUTCDate();
    hours = date.getUTCHours();
    minutes = date.getUTCMinutes();
  }

  if ([year, month, day, hours, minutes].some(isNaN)) {
    throw new Error('Try to format invalid date');
  }

  const time = [hours, minutes].map((value) => (value >= 10 ? value : '0' + value)).join(':');
  const dateString = format
    ? [year, padTo2Digits(month), padTo2Digits(day)].join(separator)
    : [padTo2Digits(day), padTo2Digits(month), year].join(separator);

  return withTime ? [dateString, time].join(' ') : dateString;
};

export const formatDateStringToISO = (dateString: string): string => {
  const parts = dateString.split('.');
  const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

  return formattedDate;
};

export const TODAY = getDateWithoutTime(new Date());
export const LELAL_AGE_DATE = new Date(TODAY.getFullYear() - LEGAL_AGE, TODAY.getMonth(), TODAY.getDate());
